
export const customertypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('customertypes', value)
  }
}
export const activecustomertypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activecustomertypes', value)
  }
}
export const jobtitles = ({ commit }, value) => {
  if (value && value[0]) {
    commit('jobtitles', value)
  }
}
export const activejobtitles = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activejobtitles', value)
  }
}
export const salutations = ({ commit }, value) => {
  if (value && value[0]) {
    commit('salutations', value)
  }
}
export const activesalutations = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activesalutations', value)
  }
}
export const regions = ({ commit }, value) => {
  if (value && value[0]) {
    commit('regions', value)
  }
}
export const activeregions = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeregions', value)
  }
}
export const mbpbranches = ({ commit }, value) => {
  if (value && value[0]) {
    commit('mbpbranches', value)
  }
}
export const activembpbranches = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activembpbranches', value)
  }
}
export const salesexecs = ({ commit }, value) => {
  if (value && value[0]) {
    commit('salesexecs', value)
  }
}
export const activesalesexecs = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activesalesexecs', value)
  }
}
export const opportunitystatuses = ({ commit }, value) => {
  if (value && value[0]) {
    commit('opportunitystatuses', value)
  }
}
export const activeOpportunityStatuses = ({ commit }, value) => {
  if (value && value[0]) {
    
  }
  commit('activeOpportunityStatuses', value)
}
export const quotestatuses = ({ commit }, value) => {
  if (value && value[0]) {
    commit('quotestatuses', value)
  }
}
export const activequotestatuses = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activequotestatuses', value)
  }
}
export const activitystatuses = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activitystatuses', value)
  }
}
export const activeactivitystatuses = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeactivitystatuses', value)
  }
}
export const activityTypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activityTypes', value)
  }
}
export const activeactivitytypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeactivitytypes', value)
  }
}
export const activeremindertypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeremindertypes', value)
  }
}
export const activityresults = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activityresults', value)
  }
}
export const activeactivityresults = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeactivityresults', value)
  }
}
export const producttypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('producttypes', value)
  }
}
export const activeproducttypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeproducttypes', value)
  }
}
export const projecttypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('projecttypes', value)
  }
}
export const activeprojecttypes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeprojecttypes', value)
  }
}
export const lostquotenotes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('lostquotenotes', value)
  }
}
export const activelostquotenotes = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activelostquotenotes', value)
  }
}
export const datemodifiers = ({ commit }, value) => {
  if (value && value[0]) {
    commit('datemodifiers', value)
  }
}
export const users = ({ commit }, value) => {
  if (value && value[0]) {
    commit('users', value)
  }
}
export const activeusers = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeusers', value)
  }
}
export const citiesTowns = ({ commit }, value) => {
  if (value && value[0]) {
    commit('citiesTowns', value)
  }
}
export const activeCitiesTowns = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeCitiesTowns', value)
  }
}
export const roles = ({ commit }, value) => {
  if (value && value[0]) {
    commit('roles', value)
  }
}
export const activeRoles = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeRoles', value)
  }
}
export const favoriteFilters = ({ commit }, value) => {
  if (value && value[0]) {
    commit('favoriteFilters', value)
  }
}
export const jobfunctions = ({ commit }, value) => {
  if (value && value[0]) {
    commit('jobfunctions', value)
  }
}
export const mbpDepartments = ({ commit }, value) => {
  if (value && value[0]) {
    commit('mbpDepartments', value)
  }
}
export const quotationGrades = ({ commit }, value) => {
  if (value && value[0]) {
    commit('quotationGrades', value)
  }
}
export const activeQuotationGrades = ({ commit }, value) => {
  if (value && value[0]) {
    commit('activeQuotationGrades', value)
  }
}
export const userWidgets = ({ commit }, value) => {
  commit('userWidgets', value)
}
export const opportunities = ({ commit }, value) => {
  commit('opportunities', value)
}
export const mbpdepts = ({ commit }, value) => {
  commit('mbpdepts', value)
}
export const contacttypes = ({ commit }, value) => {
  commit('contacttypes', value)
}
export const activequotations = ({ commit }, value) => {
  commit('activequotations', value)
}
export const parentcustomernames = ({ commit }, value) => {
  commit('parentcustomernames', value)
}
export const contacts = ({ commit }, value) => {
  commit('contacts', value)
}
export const customernames = ({ commit }, value) => {
  commit('customernames', value)
}


export const columnsSelection1 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection1', value)
  }
}
export const columnsSelection2 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection2', value)
  }
}
export const columnsSelection3 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection3', value)
  }
}
export const columnsSelection4 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection4', value)
  }
}
export const columnsSelection5 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection5', value)
  }
}
export const columnsSelection6 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection6', value)
  }
}
export const columnsSelection7 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection7', value)
  }
}
export const columnsSelection8 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection8', value)
  }
}
export const columnsSelection12 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection12', value)
  }
}
export const columnsSelection13 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection13', value)
  }
}
export const columnsSelection101 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection101', value)
  }
}
export const columnsSelection102 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('columnsSelection102', value)
  }
}


export const dbViewFields1 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields1', value)
  }
}
export const dbViewFields2 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields2', value)
  }
}
export const dbViewFields3 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields3', value)
  }
}
export const dbViewFields4 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields4', value)
  }
}
export const dbViewFields5 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields5', value)
  }
}
export const dbViewFields6 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields6', value)
  }
}
export const dbViewFields7 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields7', value)
  }
}
export const dbViewFields8 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields8', value)
  }
}
export const dbViewFields12 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields12', value)
  }
}
export const dbViewFields13 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields13', value)
  }
}
export const dbViewFields101 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields101', value)
  }
}
export const dbViewFields102 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('dbViewFields102', value)
  }
}


export const userViewFilters1 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters1', value)
  }
}
export const userViewFilters2 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters2', value)
  }
}
export const userViewFilters3 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters3', value)
  }
}
export const userViewFilters4 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters4', value)
  }
}
export const userViewFilters5 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters5', value)
  }
}
export const userViewFilters6 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters6', value)
  }
}
export const userViewFilters7 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters7', value)
  }
}
export const userViewFilters8 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters8', value)
  }
}
export const userViewFilters12 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters12', value)
  }
}
export const userViewFilters13 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('userViewFilters13', value)
  }
}


export const defUserViewFilter1 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter1', value)
  }
}
export const defUserViewFilter2 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter2', value)
  }
}
export const defUserViewFilter3 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter3', value)
  }
}
export const defUserViewFilter4 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter4', value)
  }
}
export const defUserViewFilter5 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter5', value)
  }
}
export const defUserViewFilter6 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter6', value)
  }
}
export const defUserViewFilter7 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter7', value)
  }
}
export const defUserViewFilter8 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter8', value)
  }
}
export const defUserViewFilter12 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter12', value)
  }
}
export const defUserViewFilter13 = ({ commit }, value) => {
  if (value && value[0]) {
    commit('defUserViewFilter13', value)
  }
}